import { toast } from "sonner";
import { Copy } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { bolehKelolaSurvei } from "@/lib/roles";
import { salinTeks } from "@/lib/salin";
import { formatTanggalPendek } from "@/lib/datetime";
import { TEKS_KETERANGAN_TAUTAN, tautanPeriode } from "@/lib/survei";
import SurveiBadgeKelompok from "@/components/SurveiBadgeKelompok";

// Tautan publik per periode (origin saat ini + tautan_path dari server: /survei-peserta-didik-<kode> utk Kedokteran,
// /survei-keperawatan-nakes-<kode> utk Kepnakes) + lencana kelompok + "Salin tautan". Khusus Super Admin
// (server juga hanya mengirim kode ke Super Admin). Periode yg ditutup/lewat tanggal tetap ditampilkan berlabel "berakhir".
export default function SurveiTautanPeriode({ periode }) {
    const { user } = useAuth();
    if (!bolehKelolaSurvei(user?.role)) return null;

    const salin = async (tautan) => {
        if (await salinTeks(tautan)) toast.success("Tautan disalin");
        else toast.error("Tidak bisa menyalin otomatis. Pilih tautan lalu salin secara manual.");
    };

    return (
        <Card className="space-y-4 p-4" data-testid="survei-tautan-periode">
            <p className="text-sm text-slate-600">{TEKS_KETERANGAN_TAUTAN} Bagikan tautan periode yang sedang dibuka kepada peserta didik sesuai kelompoknya.</p>
            {periode.length === 0 && <p className="text-sm text-slate-400">Belum ada periode.</p>}
            <ul className="space-y-3">
                {periode.map((p) => {
                    const berakhir = !p.aktif || p.keadaan === "tutup";
                    const tautan = tautanPeriode(p, window.location.origin);
                    return (
                        <li key={p.id} className="space-y-2 rounded-lg border border-slate-200 p-3" data-testid={`survei-tautan-${p.id}`}>
                            <div className="flex flex-wrap items-center gap-2">
                                <span className="font-semibold text-slate-800">{p.nama}</span>
                                <SurveiBadgeKelompok kelompok={p.kelompok} testId={`survei-tautan-kelompok-${p.id}`} />
                                <span className="text-xs text-slate-500">{formatTanggalPendek(p.tanggal_mulai)} – {formatTanggalPendek(p.tanggal_selesai)}</span>
                                {berakhir
                                    ? <Badge variant="outline" data-testid={`survei-tautan-berakhir-${p.id}`}>berakhir</Badge>
                                    : <Badge className="bg-emerald-600 text-white">{p.keadaan === "belum" ? "dijadwalkan" : "dibuka"}</Badge>}
                            </div>
                            {tautan ? (
                                <div className="flex flex-wrap items-center gap-2">
                                    <code className="select-all break-all rounded bg-slate-100 px-3 py-2 text-sm" data-testid={`survei-tautan-teks-${p.id}`}>{tautan}</code>
                                    <Button variant="outline" size="sm" onClick={() => salin(tautan)} data-testid={`survei-salin-${p.id}`}>
                                        <Copy className="mr-2 h-4 w-4" aria-hidden="true" /> Salin tautan
                                    </Button>
                                </div>
                            ) : (
                                <p className="text-xs text-slate-500">Tautan belum tersedia. Muat ulang halaman.</p>
                            )}
                        </li>
                    );
                })}
            </ul>
        </Card>
    );
}
